<template>
  <div>
    <b-row>
      <b-col md="6">
        <label class="mt-2">{{$t('message.Position_level')}}</label>
        <b-form-select
            v-model="title.position_level_id"
            :options="position_level"
            text-field="name_uz"
            value-field="id"
            style="height: 40px"
            class="w-100 form-select"
            @input="filterPositions"
        />
      </b-col>
      <b-col md="6">
        <label for="time">{{$t('message.Time')}}</label>
        <b-form-input
            id="time"
            value="00:00"
            type="time"
            class="mt-2"
            v-model="title.time"
        ></b-form-input>
      </b-col>
    </b-row>
    <br />
    <label class="mt-2">{{$t('message.Positions')}}</label>
    <v-select :options="positions" label="name_uz" v-model="testPositions" multiple></v-select>
<!--    <b-form-select-->
<!--        v-model="title.position_id"-->
<!--        :options="position"-->
<!--        text-field="name_uz"-->
<!--        value-field="id"-->
<!--        style="height: 40px"-->
<!--        class="w-100 form-select"-->
<!--    />-->
    <br />
    <label class="mt-2">{{$t('message.Subject')}}</label>
    <b-form-select
        v-model="title.subject_id"
        :options="subject"
        text-field="subject"
        value-field="id"
        style="height: 40px"
        class="w-100 form-select"
    />
    <br />

    <b-tabs content-class="mt-3" fill>
      <b-tab title="Uzbek" active>
        <b-form-group
            :label="$t('message.Title_uz')"
            label-for="name-input"
            invalid-feedback="Name is required"
        >
          <b-form-input
              id="name-input"
              v-model="title.title_uz"
              required
          />
        </b-form-group>
      </b-tab>
      <b-tab title="Russian">
        <b-form-group
            :label="$t('message.Title_ru')"
            label-for="name-input"
            invalid-feedback="Name is required"
        >
          <b-form-input
              id="name-input"
              v-model="title.title_ru"
              required
          />
        </b-form-group>
      </b-tab>
      <b-tab title="English">
        <b-form-group
            :label="$t('message.Title_en')"
            label-for="name-input"
            invalid-feedback="Name is required"
        >
          <b-form-input
              id="name-input"
              v-model="title.title_en"
              required
          />
        </b-form-group>
      </b-tab>
      <b-tab title="Karakalpak">
        <b-form-group
            :label="$t('message.Title_kr')"
            label-for="name-input"
            invalid-feedback="Name is required"
        >
          <b-form-input
              id="name-input"
              v-model="title.title_kr"
              required
          />
        </b-form-group>
      </b-tab>
    </b-tabs>

    <div class="mt-4 d-flex justify-content-end">
      <b-button
          variant="outline-primary"
          @click="handleClick"
      >{{$t('message.Cancel')}}
      </b-button>
      <b-button
          @click="handleSubmit"
          style="margin-left: 10px"
          variant="primary"
      >{{$t('message.Add')}}
      </b-button>
    </div>
  </div>
</template>

<script>
import {getPositions} from "../../../../../../../api/directories";
import {addTest, editTest, getTestById} from "../../../../../../../api/tests";
import {getSubjects} from "../../../../../../../api/subject";
import {getPositionLevels} from "../../../../../../../api/directories";
import vSelect from 'vue-select'


export default {
  name: "TabModal",
  components: {
    vSelect,
  },
  props: {
    id: {
      default: null,
    }
  },
  data(){
    return{
      title: {
        title_uz: '',
        title_ru: '',
        title_en: '',
        title_kr: '',
        position_level_id:[],
        position_id: [],
        subject_id:'',
        time: "",
        positions: [],
      },
      position_level: [],
      testPositions: [],
      subject: [],
      positions: [],
      activeModal: {
        type: Boolean
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    },
  },
  created() {
    this.fetchSettings()
    },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchTests(){
      getTestById({ id : this.id }).then(response => {
        this.title = response.data.data
        this.testPositions = this.title.positions.map(item => Object.assign({},item));
      })
    },
    fetchSettings() {
      getPositionLevels().then(response => {
        this.position_level = response.data.data
      })

      getSubjects().then(response => {
        this.subject = response.data.data
      })
      getPositions({id:this.title.id}).then(res => {
        this.positions = res.data.data;
      });
    },
    filterPositions() {
      this.positions = this.positions.filter(item => item.position_level_id === this.title.position_level_id)
    },
    handleSubmit() {
      if (this.title.title_uz
          && this.title.title_ru
          && this.title.title_en
          && this.title.title_kr
          && this.title.position_level_id
          && this.title.subject_id) {
        // const form = new FormData()
        // form.append('title_uz', this.title.title_uz)
        // form.append('title_ru', this.title.title_ru)
        // form.append('title_en', this.title.title_en)
        // form.append('title_kz', this.title.title_kr)
        // form.append('level_id', this.title.position_level_id)
        // form.append('position', this.title.position_id)
        // eslint-disable-next-line no-console
        console.log(this.testPositions);
        this.title.positions = [];
        for(let pos of this.testPositions) {
          // form.append('positions[]',pos.id);
          this.title.positions.push(pos.id);
        }
        // form.append('subject', this.title.subject_id)
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editTest(this.title).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addTest(this.title).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchTests()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>





